"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _router = _interopRequireDefault(require("./router"));
var _auth = require("@/utils/auth");
/*
 * @Author: dengriguang
 * @since: 2020-08-25 15:15:42
 * @lastTime: 2020-09-01 15:47:17
 * @LastAuthor: Do not edit
 * @FilePath: \yilong\src\permission.js
 * @Description: 路由权限拦截
 */

var whiteList = ["/login", "/privacy"];
_router.default.beforeEach(/*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(to, form, next) {
    var hasToken;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          hasToken = (0, _auth.getToken)();
          if (hasToken) {
            if (to.matched.length === 0) {
              next("/404");
            }
            if (to.path === "/login") {
              next({
                path: "/home"
              });
            }
            next();
          } else {
            if (whiteList.indexOf(to.path) !== -1) {
              next();
            } else {
              next({
                path: "/login"
              });
            }
          }
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {});